import { tv } from 'tailwind-variants';

export const tabbedBarChartVariants = tv({
  slots: {
    title: ['inline-block', 'text-[11.2px] text-textPrimary font-light leading-4', 'my-2.5'],
    note: [
      'inline-block',
      'text-textPrimary',
      'text-xs [--font-size:12px]',
      'font-medium [--font-weight:500]',
      'leading-[14.4px] [--line-height:14.4px]',
      'mt-6.5',
    ],
    chartWrapper: ['flex', 'flex-col'],
    barRow: ['flex', 'items-center'],
    valueLabel: ['flex-shrink-0', 'flex', 'items-center', 'justify-end', 'pr-3'],
    barWrapper: ['flex-1'],
    bar: [
      'overflow-hidden',
      'focus-visible:outline-2',
      'focus-visible:outline-offset-1',
      'focus-visible:outline-primary',
    ],
  },
});

export const tabbedBarChartConfig = {
  yAxisWidth: 60,
  fallbackColor: '#2B7BB0',
  label: {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 16,
    color: 'white',
    paddingX: 8,
    paddingY: 6,
  },
  tick: {
    fontSize: 12,
    color: 'var(--color-light-black)',
    fontWeight: 900,
  },
  animation: {
    barDuration: '0.8s',
    labelDelay: '0.3s',
    labelDuration: '0.4s',
    easing: 'ease-out',
  },
  minBarHeight: 34,
  lineHeight: 1.4,
  barGap: 8,
  domainPadding: 0.95,
};
